// client/components/system/OnboardingModal.jsx
import { useEffect, useState, useRef } from "react";
import { ArrowRight, Layout, Search, BookOpen, Check } from "lucide-react";
import { OnboardingAPI } from "../../constants/systemCommsApi.js";
import { useTheme } from "../../context/ThemeContext.jsx";
import ModalOrSheet from "../ui/ModalOrSheet.jsx";
import AppButton from "../ui/AppButton.jsx";
import { cn } from "../../utils/themeClasses.js";
const SLIDES = [{
  icon: Layout,
  title: "Willkommen bei WireTrack",
  text: "Dein Dashboard ist die Zentrale: Hier siehst du Pendenzen, Statistiken und Schnellzugriffe auf alle Bereiche. Nutze die Kacheln für den schnellen Einstieg."
}, {
  icon: Search,
  title: "Globale Suche",
  text: "Drücke Ctrl+K (oder Cmd+K) für die globale Suche. Du findest Projekte, Kunden, Service-Aufträge und mehr – blitzschnell. Favoriten erscheinen im Dashboard."
}, {
  icon: BookOpen,
  title: "Hilfe & Updates",
  text: "Im WireHub findest du Nachschlagewerk, WireMind und das integrierte Hilfe-Center an einem Ort. Release Notes informieren dich über neue Features."
}];
export default function OnboardingModal() {
    const [open, setOpen] = useState(false);
  const [step, setStep] = useState(0);
  const fetched = useRef(false);
  const mountedRef = useRef(true);
  useEffect(() => {
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
    };
  }, []);
  useEffect(() => {
    if (fetched.current) return;
    fetched.current = true;
    OnboardingAPI.status().then(d => {
      if (!mountedRef.current) return;
      if (d && d.completed === false) setOpen(true);
    }).catch(() => {});
  }, []);
  const handleNext = () => {
    if (step < SLIDES.length - 1) {
      setStep(step + 1);
    } else {
      setOpen(false);
      OnboardingAPI.complete().catch(() => {});
    }
  };
  const handleSkip = () => {
    setOpen(false);
    OnboardingAPI.complete().catch(() => {});
  };
  if (!open) return null;
  const slide = SLIDES[step];
  const Icon = slide.icon;
  const isLast = step === SLIDES.length - 1;
  return <ModalOrSheet open={open} onClose={handleSkip} maxWidth="sm">
      <div className="p-1 text-center">
          <div className={`inline-flex p-3 rounded-2xl mb-4 ${"bg-blue-500/20"}`}>
            <Icon className={`w-7 h-7 ${"text-blue-400"}`} />
          </div>

          <h2 className={`text-lg font-bold mb-2 ${"text-white"}`}>{slide.title}</h2>
          <p className={`text-sm leading-relaxed mb-6 ${"text-white/60"}`}>{slide.text}</p>

          <div className="flex items-center justify-center gap-1.5 mb-5">
            {SLIDES.map((_, i) => <div key={i} className={`w-2 h-2 rounded-full transition-colors ${i === step ? "bg-blue-500" : "bg-white/10"}`} />)}
          </div>

          <div className="flex gap-2">
            <AppButton type="button" variant="secondary" onClick={handleSkip} className={cn("flex-1 px-4 py-2.5 rounded-xl text-sm font-normal min-h-[44px]", "text-white/50")}>
              Überspringen
            </AppButton>
            <AppButton type="button" variant="primary" onClick={handleNext} className="flex-1 px-4 py-2.5 rounded-xl text-sm font-normal min-h-[44px] flex items-center justify-center gap-1.5">
              {isLast ? <>Fertig <Check className="w-3.5 h-3.5" /></> : <>Weiter <ArrowRight className="w-3.5 h-3.5" /></>}
            </AppButton>
          </div>
      </div>
    </ModalOrSheet>;
}